import { call, takeLatest } from "redux-saga/effects";
import {
  PACKING_TYPE,
  PRODUCT_CREATE,
  PRODUCT_DELETE,
  PRODUCT_DETAIL,
  PRODUCT_EDIT,
  PRODUCT_ENABLE_DESABLE,
  PRODUCT_LIST,
  PRODUCT_VERSION_DETAIL,
  PRODUCT_VERSION_LIST,
  VENDOR_DIVISION_LIST,
  FETCH_HEADQUATER_LIST,
  FETCH_DOCTOR_LIST,
  FETCH_PHARMACY_LIST,
  PRODUCT_VIEW_DOCTOR_LIST,
  PRODUCT_VIEW_PHARMACY_LIST,
  PRODUCT_DOCTOR_OFFERS_REQUEST,
  PRODUCT_PHARMACY_OFFERS_REQUEST,
  FETCH_ADD_DOCTOR_LIST,
  FETCH_ADD_PHARMACY_LIST,
  PRODUCT_ADD_DOCTOR,
  PRODUCT_ADD_PHARMACY,
} from "../actions/types";
import * as productApi from "../apis/productApi";

export function* packingTypeWorker(action) {
  try {
    const res = yield call(productApi.packingTypeApi);
    console.log(res);
    if (res.status == 200) {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productListWorker(action) {
  console.log(action);
  try {
    const res = yield call(productApi.productListApi, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productDetailWorker(action) {
  try {
    const res = yield call(productApi.productDetailApi, {
      product_id: action.id,
    });
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productCreateWorker(action) {
  try {
    const res = yield call(productApi.productCreateApi, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productEditWorker(action) {
  try {
    const res = yield call(productApi.productEditApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productEnableDisableWorker(action) {
  try {
    const res = yield call(productApi.productEnableDisale, {
      product_id: action.id,
    });
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productDeleteWorker(action) {
  try {
    const res = yield call(productApi.productDeleteApi, {
      product_id: action.id,
    });
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productVersionWorker(action) {
  try {
    const res = yield call(productApi.productVersionList, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productVersionDetailWorker(action) {
  try {
    const res = yield call(productApi.productVersionDetail, {
      product_id: action.id,
    });
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* vendorDivisionListWorker(action) {
  try {
    const res = yield call(productApi.vendorDivisionListApi);
    console.log(res);
    if (res.status == 200) {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.name,
        offer_type: ele.offer_type,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productHeadQuaterListWorker(action) {
  try {
    const res = yield call(productApi.headQuaterListApi);
    console.log(res);
    if (res.status == 200) {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productDoctorListWorker(action) {
  try {
    const res = yield call(productApi.productDoctorListApi, {
      head_quater_id: action.id,
    });
    console.log(res);
    if (res.status == 200) {
      let newArr = res.data.data.map((ele) => ({
        code: ele.code,
        value: ele.id,
        label: ele.name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productPharmacyListWorker(action) {
  try {
    const res = yield call(productApi.productPharmacyListApi, {
      head_quater_id: action.id,
    });
    console.log(res);
    if (res.status == 200) {
      let newArr = res.data.data.map((ele) => ({
        code: ele.code,
        value: ele.id,
        label: ele.pharmacy_name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productAddDoctorListWorker(action) {
  try {
    const res = yield call(productApi.productAddDoctorListApi);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productAddPharmacyListWorker(action) {
  try {
    const res = yield call(productApi.productAddPharmacyListApi);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productViewSoctorListWorker(action) {
  try {
    const res = yield call(productApi.productViewDoctorList, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productViewPharmacyListWorker(action) {
  try {
    const res = yield call(productApi.productViewPharmacyList, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productDoctorOfferReqestWorker(action) {
  try {
    const res = yield call(productApi.productDoctorOfferRequest, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productPharmacyOfferReqestWorker(action) {
  try {
    const res = yield call(productApi.productPharmacyOfferRequest, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productDoctorAddWorker(action) {
  try {
    const res = yield call(productApi.productDoctorAdd, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productPharmacyAddtWorker(action) {
  try {
    const res = yield call(productApi.productPharmacyAdd, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* packingTypeWatcher() {
  yield takeLatest(PACKING_TYPE, packingTypeWorker);
}

export function* productListWatcher() {
  yield takeLatest(PRODUCT_LIST, productListWorker);
}

export function* productDetailWatcher() {
  yield takeLatest(PRODUCT_DETAIL, productDetailWorker);
}

export function* productCreateWatcher() {
  yield takeLatest(PRODUCT_CREATE, productCreateWorker);
}

export function* productEditWatcher() {
  yield takeLatest(PRODUCT_EDIT, productEditWorker);
}

export function* productEnableDisableWatcher() {
  yield takeLatest(PRODUCT_ENABLE_DESABLE, productEnableDisableWorker);
}

export function* productDeleteWatcher() {
  yield takeLatest(PRODUCT_DELETE, productDeleteWorker);
}

export function* productVersionWatcher() {
  yield takeLatest(PRODUCT_VERSION_LIST, productVersionWorker);
}

export function* productVersionDetailWatcher() {
  yield takeLatest(PRODUCT_VERSION_DETAIL, productVersionDetailWorker);
}

export function* vendorDivisionListWatcher() {
  yield takeLatest(VENDOR_DIVISION_LIST, vendorDivisionListWorker);
}

export function* productHeadQuaterListWatcher() {
  yield takeLatest(FETCH_HEADQUATER_LIST, productHeadQuaterListWorker);
}

export function* productDoctorListWatcher() {
  yield takeLatest(FETCH_DOCTOR_LIST, productDoctorListWorker);
}
export function* productPharmacyListWatcher() {
  yield takeLatest(FETCH_PHARMACY_LIST, productPharmacyListWorker);
}
export function* productViewSoctorListWatcher() {
  yield takeLatest(PRODUCT_VIEW_DOCTOR_LIST, productViewSoctorListWorker);
}
export function* productViewPharmacyListWatcher() {
  yield takeLatest(PRODUCT_VIEW_PHARMACY_LIST, productViewPharmacyListWorker);
}
export function* productDoctorOfferReqestWatcher() {
  yield takeLatest(
    PRODUCT_DOCTOR_OFFERS_REQUEST,
    productDoctorOfferReqestWorker
  );
}
export function* productPharmacyOfferReqestWatcher() {
  yield takeLatest(
    PRODUCT_PHARMACY_OFFERS_REQUEST,
    productPharmacyOfferReqestWorker
  );
}

export function* productAddDoctorListWatcher() {
  yield takeLatest(FETCH_ADD_DOCTOR_LIST, productAddDoctorListWorker);
}
export function* productAddPharmacyLisWatcher() {
  yield takeLatest(FETCH_ADD_PHARMACY_LIST, productAddPharmacyListWorker);
}
export function* productDoctorAddWatcher() {
  yield takeLatest(PRODUCT_ADD_DOCTOR, productDoctorAddWorker);
}
export function* productPharmacyAddWatcher() {
  yield takeLatest(PRODUCT_ADD_PHARMACY, productPharmacyAddtWorker);
}
